import React from "react";
import { formatMXNCompact } from "../../lib/api";

export default function KpiCard({
  label,
  value,
  hint,
  icon: Icon,
  tone = "neutral", // neutral | positive | negative | accent
  testid,
}) {
  const toneClasses = {
    neutral: "text-ink",
    positive: "text-sage-700",
    negative: "text-clay",
    accent: "text-sage-900",
  };
  return (
    <div
      className="rounded-3xl bg-white border border-line/70 shadow-card p-5 transition-all hover:shadow-cardHover hover:-translate-y-0.5"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-bold tracking-[0.16em] uppercase text-sage-700">
          {label}
        </span>
        {Icon && (
          <div className="h-8 w-8 rounded-full bg-sage-50 text-sage-700 flex items-center justify-center">
            <Icon size={16} strokeWidth={2} />
          </div>
        )}
      </div>
      <p className={`mt-3 font-display text-2xl font-extrabold tabular ${toneClasses[tone]}`}>
        {typeof value === "number" ? formatMXNCompact(value) : value}
      </p>
      {hint && <p className="mt-1 text-xs text-soft">{hint}</p>}
    </div>
  );
}
